// extracted by mini-css-extract-plugin
export default {"pureButton":"pure-button_pureButton__hQCwN"};